import { COUNTRY_PHONE_CODES } from '@/utils/constants/countries'

const FormatCountry = country => {
  const formatedCountry = COUNTRY_PHONE_CODES.find(el => el.code === country)

  return formatedCountry.name
}

export default FormatCountry
